import {LobbyImage} from '@colonist/types'
import {TranslationObject} from '@colonist/i18n'
import {UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'
import {createShuffleQueueIconStack} from '../../../../../../../shared/scripts/matchmaking/ShuffleQueueUtils'
import {ClientShuffleQueueController} from '../../../../../../../shared/scripts/shuffle/ClientShuffleQueueController'
import {createDivIn, createImgIn} from '../../../../../../../shared/scripts/ui_utils/DomUtils'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class UIMMatchmakingSearchingShuffleView extends UIMMatchmakingSearchingView<MatchmakingMatchTypes.UnrankedShuffle> {
    constructor(matchmakingController: UIMMatchmakingController) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const title: TranslationObject = {key: 'strings:homePage.unranked.shuffle'}
        const imageSrc = LobbyImage.GameModeShuffle

        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.UnrankedShuffle)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }

    addImage() {
        const shuffleQueueData = ClientShuffleQueueController.shuffleQueueData
        if(shuffleQueueData == undefined) {
            super.addImage()
            return
        }

        const shuffleSearchImageContainer = createDivIn(this.body, 'm-matchmaking-search-image')

        const stackedIcon = createShuffleQueueIconStack(shuffleQueueData.mapId, shuffleQueueData.modeId)
        if(stackedIcon) {
            stackedIcon.classList.add('m-gamemode-img')
            shuffleSearchImageContainer.appendChild(stackedIcon)
        }

        createImgIn(shuffleSearchImageContainer, LobbyImage.MatchmakingSearch, 'm-gamemode-search-icon')
    }
}
